/* Keep the artist ItemList aligned with the asynchronously rendered cards. */
(function () {
  'use strict';

  function init() {
    var grid = document.getElementById('artist-products-grid');
    var artistSchema = document.getElementById('artist-structured-data');
    if (!grid || !artistSchema || grid.dataset.itemListSchemaBound) return;
    var graph;
    try {
      graph = JSON.parse(artistSchema.textContent)['@graph'];
    } catch (error) {
      return;
    }
    var page = graph && graph.find(function (node) { return node['@type'] === 'WebPage'; });
    if (!page || !page.url) return;
    grid.dataset.itemListSchemaBound = 'true';

    function update() {
      var elements = [];
      var seen = new Set();
      grid.querySelectorAll('.artist-product-card').forEach(function (card) {
        var link = card.querySelector('a[href]');
        var heading = card.querySelector('h3');
        if (!link || !heading || !heading.textContent.trim()) return;
        var url;
        try {
          url = new URL(link.getAttribute('href'), page.url);
        } catch (error) {
          return;
        }
        if (url.origin !== new URL(page.url).origin || !url.pathname.includes('/products/')) return;
        url.search = '';
        url.hash = '';
        if (seen.has(url.href)) return;
        seen.add(url.href);
        elements.push({
          '@type': 'ListItem',
          position: elements.length + 1,
          item: {
            '@type': 'Product',
            '@id': url.href + '#product',
            name: heading.textContent.trim(),
            url: url.href
          }
        });
        var priceText = card.getAttribute('data-offer-price');
        var currency = card.getAttribute('data-offer-currency');
        var available = card.getAttribute('data-offer-available');
        var price = Number(priceText);
        if (priceText !== null && priceText.trim() !== '' && Number.isFinite(price) && price >= 0 &&
            /^[A-Z]{3}$/.test(currency || '') && (available === 'true' || available === 'false')) {
          var offerUrl = new URL(url.href);
          var variant = card.getAttribute('data-offer-variant');
          if (/^\d+$/.test(variant || '')) offerUrl.searchParams.set('variant', variant);
          var offer = {
            '@type': 'Offer',
            '@id': offerUrl.href + '#offer',
            url: offerUrl.href,
            priceCurrency: currency,
            price: price.toFixed(2),
            availability: 'https://schema.org/' + (available === 'true' ? 'InStock' : 'OutOfStock')
          };
          var compareAt = Number(card.getAttribute('data-offer-compare-at'));
          if (Number.isFinite(compareAt) && compareAt > price) {
            offer.priceSpecification = {
              '@type': 'UnitPriceSpecification',
              price: compareAt.toFixed(2),
              priceCurrency: currency,
              priceType: 'https://schema.org/StrikethroughPrice'
            };
          }
          elements[elements.length - 1].item.offers = offer;
        }
        var image = card.querySelector('img');
        var imageSource = image && image.getAttribute('src');
        if (imageSource) {
          try {
            var imageUrl = new URL(imageSource, page.url);
            if (imageUrl.protocol === 'https:' || imageUrl.protocol === 'http:') {
              elements[elements.length - 1].item.image = imageUrl.href;
            }
          } catch (error) {
            // Leave image out when the card has no valid image URL.
          }
        }
      });
      var script = document.getElementById('artist-products-structured-data');
      if (!elements.length) {
        if (script) script.remove();
        return;
      }
      var listId = page.url + '#products';
      var data = {
        '@context': 'https://schema.org',
        '@graph': [
          { '@type': 'WebPage', '@id': page['@id'], mentions: { '@id': listId } },
          {
            '@type': 'ItemList',
            '@id': listId,
            name: 'Related Albums by ' + page.name,
            numberOfItems: elements.length,
            itemListElement: elements
          }
        ]
      };
      if (!script) {
        script = document.createElement('script');
        script.id = 'artist-products-structured-data';
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
    }

    new MutationObserver(update).observe(grid, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['src', 'data-offer-price', 'data-offer-compare-at',
        'data-offer-currency', 'data-offer-available', 'data-offer-variant']
    });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
